import { render, staticRenderFns } from "./ListarContratosCliente.vue?vue&type=template&id=65c14d7d"
import script from "./ListarContratosCliente.vue?vue&type=script&lang=js"
export * from "./ListarContratosCliente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports